var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('note',{attrs:{"title":_vm.$t('attention'),"description":_vm.$t('server_permission_required', {
    replace: _vm.collection(_vm.permission_requirements).pluck('folder').join(', ')})}})}
var staticRenderFns = []

export { render, staticRenderFns }